var exports = {
  "rv": "KeybindHint.module__tooltipContent___N0ZDeF",
  "Pf": "KeybindHint.module__label___N0ZDeF",
  "g": "KeybindHint.module__keybindHint___N0ZDeF",
  "Eb": "KeybindHint.module__key___N0ZDeF",
  "WK": "KeybindHint.module__keySymbol___N0ZDeF" + " " + "KeybindHint.module__key___N0ZDeF",
};

module.exports = exports;
